<template>
  <v-app>
    <LoginView />
  </v-app>
</template>

<style>
.v-application {
  font-size: 0.8em;
}
</style>

<script setup lang="ts">
import LoginView from '@/views/LoginView.vue';
</script>
